<template>
    <nav class="site-navbar">
        <div class="site-navbar__header">
            <img class="site-navbar__brand-lg" src="~@/assets/images/logo.png">
            <!--<h1 class="site-navbar__brand" @click="$router.push({ name: 'home' })">-->
                <!--<img class="site-navbar__brand-lg" src="~@/assets/images/logo.png">-->
                <!--<img class="site-navbar__brand-mini" src="" alt="">-->
            <!--</h1>-->
        </div>
        <div class="site-navbar__body clearfix">
            <el-menu
                    class="site-navbar__menu"
                    mode="horizontal">
                <el-menu-item class="site-navbar__switch" index="0" @click="sidebarFold = !sidebarFold">
                    <!--<icon-svg name="zhedie"></icon-svg>-->
                </el-menu-item>
            </el-menu>
            <el-menu class="site-navbar__menu site-navbar__menu--right" mode="horizontal">
                <el-menu-item class="site-navbar__avatar" index="3">
                    <el-dropdown :show-timeout="0" placement="bottom" trigger="click">
                        <span class="el-dropdown-link userinfo-inner" style="color: #333;">
                            <i class="icon-user"></i> {{userName}} <i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="updatePasswordHandle()">修改密码</el-dropdown-item>
                            <el-dropdown-item @click.native="logoutHandle()">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-menu-item>
            </el-menu>
        </div>
        <!-- 弹窗, 修改密码 -->

        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" :append-to-body="true" width="30%">
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px" size="small">
                <el-form-item label="账号">
                    <el-input v-model="dataForm.username" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="password">
                    <el-input type="password" v-model="dataForm.password"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="confirmPassword">
                    <el-input type="password" v-model="dataForm.confirmPassword"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false" size="small">取消</el-button>
              <el-button type="primary" @click="dataFormSubmit()" size="small">确定</el-button>
            </span>
        </el-dialog>
    </nav>
</template>

<script>
    import { modifyPassword } from '../api/api'
    import { clearLoginInfo } from '@/utils'

    export default {
        data(){
            var validateConfirmPassword = (rule, value, callback) => {
                if (this.dataForm.password !== value) {
                  callback(new Error('确认密码与新密码不一致'))
                } else {
                  callback()
                }
            };
            return {
                sidebarFold:false,
                dialogFormVisible:false,
                dataForm: {
                    username: '',
                    password: '',
                    confirmPassword:''
                },
                dataRule: {
                    password: [
                      { required: true, message: '新密码不能为空', trigger: 'blur' }
                    ],
                    confirmPassword: [
                      { required: true, message: '确认密码不能为空', trigger: 'blur' },
                      { validator: validateConfirmPassword, trigger: 'blur' }
                    ]
                }
            }
        },
        created (){
          this.userName = sessionStorage.getItem("username")
        },
        methods: {
            // 修改密码
            updatePasswordHandle () {
                this.dialogFormVisible = true;
                this.dataForm.username = this.userName
            },
            // 退出
            logoutHandle () {
                this.$confirm(`确定进行[退出]操作?`, '提示', {
                    type: 'warning'
                }).then(() => {
                    clearLoginInfo();
                    this.$router.push('/login');
                }).catch(() => {

                });
            },
            dataFormSubmit () {
                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        let para = {
                            username: this.dataForm.username,
                            password: this.dataForm.password
                        };
                      modifyPassword(para).then((res) => {
                            if (res.data.code === 0) {
                                this.editLoading = false;
                                this.$message.success('修改密码成功');
                                this.$router.push('/login');
                            } else {
                                this.editLoading = false;
                                this.$message.error('修改密码失败');
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/main-navbar.vue